import { Button } from '@/lib/base/buttons/button';

export function ReportProblemButton({ onClick }: { onClick: () => void }) {
  return (
    <Button color='secondary' size='md' onClick={onClick}>
      Report a problem
    </Button>
  );
}
